function getWeekdayItems(): kendo.ui.ButtonGroupItem[] {
    const d = window.getLocaleDict().weekdays;
    return [
        { text: d.mon, encoded: false },
        { text: d.tue, encoded: false },
        { text: d.wed, encoded: false },
        { text: d.thu, encoded: false },
        { text: d.fri, encoded: false },
        { text: d.sat, encoded: false },
        { text: d.sun, encoded: false }
    ];
}

function renderWorkDays(dataItem: { Id: number; WorkDays?: number[] }, prefix: string): string {
    if (!dataItem.Id) {
        return '';
    }

    const containerId = `${prefix}_${dataItem.Id}`;
    const workDays = dataItem.WorkDays ?? [];

    requestAnimationFrame(() => {
        const $el = $(`#${containerId}`);
        if (!$el.length || $el.data('kendoButtonGroup')) {
            return;
        }

        $el.kendoButtonGroup({ selection: 'multiple', items: getWeekdayItems() });

        const bg = $el.data('kendoButtonGroup');

        if (bg) {
            workDays.forEach((day) => bg.select(day));
            $el.css('pointer-events', 'none');
        }
    });

    return `<div id="${containerId}"></div>`;
}

window.renderWorkDays = renderWorkDays;
